<template>
  <div style="width:100%;">
    <v-row width="100%">
      <v-col class="text-center">
        <div @click="choice(1)">
          <img
            eager
            src="@/assets/emojis/1.png"
            v-if="select === 0"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=01.png`
            "
            v-if="select > 1"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=01-preenchido.png`
            "
            v-if="select === 1"
            width="100%"
          />
        </div>
      </v-col>
      <v-col class="text-center">
        <div @click="choice(2)">
          <img
            eager
            src="@/assets/emojis/2.png"
            v-if="select === 0"
            width="100%"
          />
          <img
            eager
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=02.png`"
            v-if="select < 2 && select != 0"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=02.png`
            "
            v-if="select > 2"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=02-preenchido.png`
            "
            v-if="select === 2"
            width="100%"
          />
        </div>
      </v-col>
      <v-col class="text-center">
        <div @click="choice(3)">
          <img
            eager
            src="@/assets/emojis/3.png"
            v-if="select === 0"
            width="100%"
          />
          <img
            eager
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=03.png`"
            v-if="select < 3 && select != 0"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=03.png`
            "
            v-if="select > 3"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=03-preenchido.png`
            "
            v-if="select === 3"
            width="100%"
          />
        </div>
      </v-col>
      <v-col class="text-center">
        <div @click="choice(4)">
          <img
            eager
            src="@/assets/emojis/4.png"
            v-if="select === 0"
            width="100%"
          />
          <img
            eager
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=04.png`"
            v-if="select < 4 && select != 0"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=04.png`
            "
            v-if="select > 4"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=04-preenchido.png`
            "
            v-if="select === 4"
            width="100%"
          />
        </div>
      </v-col>
      <v-col class="text-center">
        <div @click="choice(5)">
          <img
            eager
            src="@/assets/emojis/5.png"
            v-if="select === 0"
            width="100%"
          />
          <img
            eager
            :src="`https://comenta.ai/assets/tint.php?hex=4C4C4C&image=05.png`"
            v-if="select < 5 && select != 0"
            width="100%"
          />
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=05-preenchido.png`
            "
            v-if="select === 5"
            width="100%"
          />
        </div>
      </v-col>
    </v-row>
    <div v-if="subSelected && motive">
      <v-chip
        class="ma-1"
        label
        x-small
        color="primary"
        v-for="(item, i) in motive"
        :key="i"
      >
        {{ item.title }}
      </v-chip>
    </div>

    <v-dialog v-if="questions" v-model="dialog" fullscreen hide-overlay>
      <v-card
        flat
        class="text-center"
        v-if="select > 0 && select < 5 && subSelected === false"
        max-width="640px"
      >
        <v-container>
          <Barra :zoom="zoom" />
          <div class="text-left">
            <v-icon @click="close(false)">mdi-close</v-icon>
          </div>
          <img
            eager
            :src="
              `https://comenta.ai/assets/tint.php?hex=${color}&image=0${select}.png`
            "
            class="mt-10"
          />
          <h1 class="text-center text-secondary"><b>O que aconteceu?</b></h1>

          <v-chip
            v-for="(item, i) in questions"
            :key="i"
            label
            :outlined="getColor(item) === 'gray'"
            :color="getColor(item)"
            class="ma-2"
            @click="addMotive(item)"
          >
            {{ item.title }}
          </v-chip>
          <div class="text-center button-box">
            <v-btn
              rounded
              block
              depressed
              color="primary"
              dark
              x-large
              class="mt-5"
              @click="close(true)"
            >
              <h2><b>Confirmar</b></h2>
            </v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Barra from "@/components/Barra.vue";

export default {
  components: {
    Barra,
  },
  props: {
    value: Object,
    result: Object,
    questions: Array,
    zoom: Number,
    id: Number,
    actual: Number,
    chave: Number,
  },
  computed: {
    color() {
      return this.$vuetify.theme.themes.light.primary.split("#")[1];
    },
  },
  data: () => ({
    select: 0,
    subSelected: false,
    dialog: false,
    motive: [],
  }),
  watch: {
    select() {
      this.$emit("input", {
        value: this.select,
        motive: this.motive,
        id: this.id,
      });
      // this.result = { value: this.select, motive: this.motive }
    },
  },
  methods: {
    close() {
      this.subSelected = true;
      this.dialog = false;
    },
    choice(v) {
      this.select = v;
      this.subSelected = false;
      if (v < 5 && this.questions.length > 0) {
        this.dialog = true;
      } else {
        this.motive = [];
        this.dialog = false;
      }
    },
    addMotive(item) {
      const check = this.includes(item);
      let index = check.index;
      if (check.included) {
        this.motive.splice(index, 1);
      } else {
        this.motive.push(item);
      }
    },
    includes(item) {
      let included = false;
      let index = 0;
      for (let i = 0; i < this.motive.length; i++) {
        const element = this.motive[i];
        if (item.id === element.id) {
          included = true;
          index = i;
        }
      }
      return { included: included, index: index };
    },
    getColor(item) {
      const check = this.includes(item);
      if (check.included) {
        return "primary";
      }
      return "gray";
    },
  },
};
</script>

<style>
.button-box {
  width: 60%;
  margin: 0 auto;
}
</style>
